<div class="dialog-call flex-column">
    <div mat-dialog-title class="dflex">
        <span> Add Student Details </span>       
        <button mat-icon-button style="float: right;"
            class="mat-focus-indicator close-button mat-icon-button mat-button-base" mat-dialog-close>
            <mat-icon class="mt-1 location_icon" color="primary">
                close
            </mat-icon>
        </button>
    </div>
</div>
<mat-divider></mat-divider>
<mat-dialog-content>
    <div style="margin-top: 10px;">
        <div class="row form-group">
            <div class="col-sm-12">
                <mat-slide-toggle [checked]="false" labelPosition="before" (change)="navigateCompliance($event)">Does this person have an Institution ID ?</mat-slide-toggle>    
            </div>
            <div class="col-sm-6" *ngIf="hasInstitutionId">
                <mat-form-field style="display:flex;flex-direction: column;">
                    <mat-label>Institution ID</mat-label>
                    <input matInput placeholder="xx-xxx-xxxx" mask="00-000-0000" [(ngModel)]="institutionId">
                </mat-form-field>
                <div style="color:red" *ngIf="!validInstitutionId">
                    {{errorMessage}}
                </div>
            </div>
            <div class="col-sm-12 d-none">
                <mat-slide-toggle [checked]="false" labelPosition="before" (change)="navigateWorkdayCompliance($event)">Does this person have a Workday ID ?</mat-slide-toggle>    
            </div>
            <div class="col-sm-6 d-none" *ngIf="hasWorkdayId">
                <mat-form-field style="display:flex;flex-direction: column;">
                    <mat-label>Workday ID</mat-label>
                    <input matInput placeholder="xxxxxxxx" mask="00000000" [(ngModel)]="workdayId">
                </mat-form-field>
                <div style="color:red" *ngIf="!validWorkdayId">
                    {{errorMessage}}
                </div>
            </div>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button class="mb-2" mat-raised-button color="primary" (click)="proceed()">
        <mat-icon>save</mat-icon> Proceed
    </button>
</mat-dialog-actions>